import { FETCH_MONITORED_DOCUMENT_VERSION } from '../actions/MonitoredDocumentActions';

// INITIALIZE STATE
const initialState = {
    monitoredDocumentVersion: null,
    fetching: false,
    fetched: false,
    failed: false,
};

// REDUCER
export const MonitoredDocumentVersionReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_MONITORED_DOCUMENT_VERSION}_PENDING`:
            return {
                ...state,
                monitoredDocumentVersion: null,
                fetching: true,
                fetched: false,
                failed: false,
            };
        case `${FETCH_MONITORED_DOCUMENT_VERSION}_FULFILLED`:
            return {
                ...state,
                monitoredDocumentVersion: action.payload,
                fetching: false,
                fetched: true,
                failed: false,
            };
        case `${FETCH_MONITORED_DOCUMENT_VERSION}_REJECTED`:
            return {
                ...state,
                monitoredDocumentVersion: null,
                fetching: false,
                fetched: false,
                failed: true,
            };
        default:
            return state;
    }
};
